export interface ResizablePanelDimensions {
    width: string;
    height: string;
}

interface ResizeStrategy {
    getNewDimension: (elementRef: HTMLElement) => number;
    size: (
        defaultResizableDimension: number | null,
        startingResizableDimension: number
    ) => ResizablePanelDimensions;
}

const horizontalResizeStrategy: ResizeStrategy = {
    getNewDimension: (elementRef: HTMLElement): number => {
        return (
            (elementRef.clientWidth / document.documentElement.clientWidth) *
            100
        );
    },
    size: (
        defaultResizableDimension: number | null,
        startingResizableDimension: number
    ): ResizablePanelDimensions => {
        const resizableDimension =
            defaultResizableDimension ?? startingResizableDimension;

        return { width: `${resizableDimension}vw`, height: "100%" };
    },
};

const verticalResizeStrategy: ResizeStrategy = {
    getNewDimension: (elementRef: HTMLElement): number => {
        return (
            (elementRef.clientHeight / document.documentElement.clientHeight) *
            100
        );
    },
    size: (
        defaultResizableDimension: number | null,
        startingResizableDimension: number
    ): ResizablePanelDimensions => {
        const resizableDimension =
            defaultResizableDimension ?? startingResizableDimension;

        return { width: "100%", height: `${resizableDimension}vh` };
    },
};

export const useResizeStrategy = (isHorizontal: boolean): ResizeStrategy =>
    isHorizontal ? horizontalResizeStrategy : verticalResizeStrategy;
